<template>
  <div class="cube-fr-print">
    <cube-button
v-if="isPreviewNoData_"
:loading=previewLoading
style="margin-right: 6px;"
icon="cnd-eyes"
      type="secondary"
@click="preview">
      <cnd-icon name="cnd-eyes" />
      <span class="pl-4">预览</span>
    </cube-button>
    <el-popover v-model="visible" :disabled="!showQuiteConfig" trigger="hover">
      <div>
        <cube-checkbox v-model="userQuiteConfig">静默打印</cube-checkbox>
        <el-popover trigger="hover">
          <span>
            请先<span class="cube-fr-print-quite-tip" @click="clickDownload">下载</span>静默打印软件。
            <span class="cube-fr-print-quite-tip" @click="clickGuide">“静默配置指南”</span>
          </span>
          <i slot="reference" style="color:#3d77cd" class="el-icon-warning"></i>
        </el-popover>
      </div>
      <cube-button slot="reference" :loading="printLoading" :disabled="!reportlets && !reportList" icon="el-icon-printer" type="primary" @click="print">打印</cube-button>
    </el-popover>
    <login-dialog ref="login" :visible.sync="loginVisible" @cancel="printLoading = false" @login="login" />
    <local-dialog
title="打印列表"
:visible.sync="printVisible"
:show-close="true"
:fullscreen="false"
:append-to-body="true"
      width="300px"
:destroy-on-close="destroyOnClose"
@close="handleCancel">
      <template slot="content">
        <el-checkbox-group v-model="useReportListResult">
          <div v-for="(item, index) in useReportList" :key="index">
            <el-checkbox :label="item">{{ computedLabel_(item) }}</el-checkbox>
          </div>
        </el-checkbox-group>
      </template>
      <template slot="footer">
        <div style="display: flex;justify-content: space-between;">
          <div>
            <div v-if="showQuiteConfig">
              <cube-checkbox v-model="userQuiteConfig">静默打印</cube-checkbox>
              <el-popover trigger="hover">
                <span>
                  请先<span class="cube-fr-print-quite-tip" @click="clickDownload">下载</span>静默打印软件。
                  <span class="cube-fr-print-quite-tip" @click="clickGuide">“静默配置指南”</span>
                </span>
                <i slot="reference" style="color:#3d77cd" class="el-icon-warning"></i>
              </el-popover>
            </div>
          </div>
          <div>
            <cube-button v-if="isPreview_" :disabled="disabledPrint_" icon="cnd-eyes" type="secondary" @click="preview">
              <cnd-icon name="cnd-eyes" />
              <span class="pl-4">预览</span>
            </cube-button>
            <cube-button :loading="printLoading" :disabled="disabledPrint_" type="primary" @click="confirmPrint">
              打印
            </cube-button>

          </div>
        </div>
      </template>
    </local-dialog>
  </div>
</template>
<script>
import utils from '../../common/utils.js'
import loginDialog from '../../common/login.vue'
import localDialog from '../../../Dialog/index.js'
import { request } from '@cndinfo/cube-web-utils'
import '../../../../../lib/styles/components/FinePrint.scss'
export default {
  name: 'FrPrint',
  components: {
    loginDialog,
    localDialog
  },
  props: {
    // 打印列表内容
    reportList: {
      type: String,
      default: ''
    },
    // 实际打印的报表模版内容，空则禁止打印
    reportlets: {
      type: String,
      default: ''
    },
    // 是否支持预览
    isPreview: {
      type: Boolean,
      default: false
    },
    // 是否静默打印
    isQuitePrint: {
      type: Boolean,
      default: false
    },
    // 用户对静默打印是否可选，若设置isQuitePrint为true时，默认勾选
    showQuiteConfig: {
      type: Boolean,
      default: false
    },
    loginPath: {
      type: String,
      default: '/webroot/decision/login/cross/domain'
    },
    printUrl: {
      type: String,
      default: ''
    },
    origin: {
      type: String,
      default: ''
    },
    iframeId: {
      type: String,
      default: 'fineReportIframe'
    },
    isPopUp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      previewLoading: false,
      loginVisible: false,
      userQuiteConfig: false,
      visible: false,
      printVisible: false,
      useReportListResult: [],
      useReportList: [],
      useReportlets: [],
      currentClick: 'print',
      username: '',
      password: '',
      msg: null,
      taskList: [],
      printLoading: false,
      sysConfig: {}
    }
  },
  computed: {
    disabledPrint_() {
      if (this.reportlets) {
        return false
      }
      if (!this.reportlets && !this.useReportListResult.length) {
        return true
      }
      if (this.useReportListResult.length) {
        return false
      }
      return true
    },
    isPreviewNoData_() {
      return this.isPreview && this.reportlets.length
    },
    isPreview_() {
      return this.isPreview && this.useReportList.length
    },
    isQuitePrint_() {
      return this.isQuitePrint
    },
    computedLabel_() {
      return item => {
        const split = item && item.reportlet.split('.')
        return split[0]
      }
    },
    origin_() {
      const sysOrigin = this.sysConfig['sys.print.access.address']
      return this.origin || sysOrigin
    },
    printUrl_() {
      const sysOrigin = this.origin_
      const sysUrl = this.sysConfig['sys.print.origin.url']
      const res = sysOrigin && sysUrl ? sysOrigin + sysUrl : sysOrigin + this.printUrl
      return res
    }
  },
  watch: {
    showQuiteConfig: {
      handler(val) {
        if (val && this.isQuitePrint) {
          this.userQuiteConfig = true
        }
      },
      immediate: true
    },
    isQuitePrint(val) {
      if (!val && this.showQuiteConfig) {
        this.userQuiteConfig = false
      }
    },
    reportList: {
      handler(val) {
        if (val) {
          try {
            this.useReportList = JSON.parse(val)
          } catch (e) {
            console.log(e)
          }
        }
      },
      immediate: true
    }
  },
  mounted() {
    if (!this.origin_) {
      request({
        url: 'system/sysParamInfo/detail/param.config',
        method: 'POST',
        noLoading: true
      }).then(res => {
        this.$set(this, 'sysConfig', res.data)
      })
    }

    const messageEvent = (event) => {
      const { code, id } = event.data
      if (id === this.iframeId) {
        if (code && code === 200) {
          this.loginVisible && (this.loginVisible = false)
          this.printVisible && (this.printVisible = false)
          this.$refs.login.hideLoading()
          if (this.username && this.password) {
            utils.saveFineUser(
              this.username,
              this.password
            )
          }
          if (this.taskList.length) {
            this.taskList.forEach(item => {
              const task = item
              const p = task.params
              task.fn(p[0], p[1], p[2])
              this.taskList.shift()
            })
          }
        } else if (code && code === 500) {
          if (this.msg) {
            this.$message.error('操作失败，请检查账户名及密码是否正确。')
            this.msg.close()
            this.msg = null
          } else {
            this.msg = this.$message({
              type: 'error',
              message: '操作失败，请检查账户名及密码是否正确。'
            })
          }
          utils.removeIframe(this.iframeId)
          utils.removeFineUser()
          this.loginVisible = true
          this.$refs.login.hideLoading()
          this.hasLoadedReport = false
          this.taskList = []
          localStorage.removeItem(this.iframeId + '-hasload')
        }
      }
    }
    window.addEventListener('message', messageEvent, false)
    this.$once('hook:beforeDestroy', () => {
      utils.removeIframe(this.iframeId)
      localStorage.removeItem(this.iframeId + '-hasload')
      window.removeEventListener('message', messageEvent, false)
    })
    utils.removeIframe(this.iframeId)
    const load = localStorage.getItem(this.iframeId + '-hasload')
    if (load !== null && load !== undefined) {
      localStorage.removeItem(this.iframeId + '-hasload')
    }
  },

  methods: {
    send(sendCb) {
      const cb = () => {
        const config = {
          data: {
            reportlets: []
          }
        }
        const methods = 'console.log()'
        utils.sendMessageToIframe(JSON.stringify(config) + '---' + methods + '---' + this.iframeId, this.iframeId, this.origin_)
      }
      const info = {
        origin: this.origin_,
        loginPath: this.loginPath,
        iframeId: this.iframeId
      }
      const user = {
        username: this.username,
        password: this.password
      }
      utils.doSubmit(cb, info, user)
      sendCb()
    },
    login(res) {
      utils.removeIframe(this.iframeId)
      const load = localStorage.getItem(this.iframeId + '-hasload')
      if (load !== null && load !== undefined) {
        localStorage.removeItem(this.iframeId + '-hasload')
      }
      this.username = res.username
      this.password = res.password
      if (this.currentClick === 'print') {
        const cb = () => {
          this.taskList.push({
            params: false,
            fn: this.commonPrint
          })
        }
        this.send(cb)
      } else if (this.currentClick === 'preview') {
        const cb = () => {
          this.taskList.push({
            params: false,
            fn: this.preview
          })
        }
        this.send(cb)
      }
    },
    // 弹窗后选择内容点击确认的打印
    confirmPrint() {
      this.printLoading = true
      if (this.useReportListResult.length) {
        this.sendSubmit(this.useReportListResult, this.handleCallBack)
      } else if (this.reportlets) {
        // 直接打印
        this.sendSubmit(this.reportlets, this.handleCallBack)
      }
    },
    // 预览
    preview() {
      this.previewLoading = true
      if (!utils.checkFineUser()) {
        // 没有用户名和密码，应该提示登录
        this.currentClick = 'preview'
        this.loginVisible = true
        this.previewLoading = false
        return
      }
      if (this.useReportListResult.length) {
        // 选择内容之后的预览
        this.throttled(this.sendSubmit(this.useReportListResult, this.handlePreviewCallBack), 500)
      } else if (this.reportlets) {
        // 默认的预览
        this.throttled(this.sendSubmit(this.reportlets, this.handlePreviewCallBack), 500)
      }
    },
    print() {
      this.printLoading = true
      if (!utils.checkFineUser()) {
        // 没有用户名和密码，应该提示登录
        this.currentClick = 'print'
        this.loginVisible = true
      } else {
        this.commonPrint()
      }
    },
    commonPrint() {
      if (this.useReportList.length) {
        // 选择内容
        this.useReportListResult = []
        this.printVisible = true
        this.printLoading = false
      } else if (this.reportlets) {
        // 直接打印
        this.sendSubmit(this.reportlets, this.handleCallBack)
      }
    },
    sendSubmit(params, fn) {
      const info = {
        origin: this.origin_,
        loginPath: this.loginPath,
        iframeId: this.iframeId
      }
      const user = {
        username: this.username,
        password: this.password
      }
      this.send(() => {
        this.taskList.push({ params: [fn(params), info, user], fn: utils.doSubmit })
      })
    },
    handleCallBack(reportlets) {
      const cb = (res) => {
        const report = typeof reportlets === 'string' ? JSON.parse(reportlets) : reportlets
        this.createParams(report)
        this.printLoading = false
        this.$refs.login.hideLoading()
      }
      return cb
    },
    handlePreviewCallBack(reportlets) {
      const cb = (res) => {
        const report = typeof reportlets === 'string' ? JSON.parse(reportlets) : reportlets
        this.createParams(report, false, 'doURLPDFPrint')
        this.previewLoading = false
        this.$refs.login.hideLoading()
      }
      return cb
    },
    createParams(reportlets, isPopUp, method = 'doURLPrint') {
      const config = {
        isPopUp: isPopUp !== undefined ? isPopUp : this.isPopUp,
        data: {
          reportlets: reportlets, // 需要打印的模板列表
          __cumulatepagenumber__: false // 每个模板的页码独立
        }
      }
      if (method === 'doURLPDFPrint') {
        config.url = this.printUrl_
      } else if (method === 'doURLPrint') {
        config.printUrl = this.printUrl_
        config.type = 'print'
        config.printType = this.showQuiteConfig === false && this.isQuitePrint ? 1 : this.userQuiteConfig ? 1 : 0
        config.ieQuietPrint = true
        config.pageType = 0
        config.pageIndex = ''
        config.copy = 0
      }
      const methods = `FR.${method}(config)`
      const iframeId = this.iframeId
      const origin = this.origin_
      utils.sendMessageToIframe(JSON.stringify(config) + '---' + methods + '---' + iframeId, iframeId, origin)
    },
    clickGuide() {
      window.open('https://help.fanruan.com/finereport/doc-view-2489.html')
    },
    throttled(fn, delay = 500) {
      let timer = null
      return function(...args) {
        if (!timer) {
          timer = setTimeout(() => {
            fn.apply(this, args)
            timer = null
          }, delay)
        }
      }
    },
    checkUser() {
      return !!this.username && !!this.password
    },
    clickDownload() {
      // 点击静默打印下载软件，打开新的页面
      // 判断当前的操作系统
      const userAgent = navigator.userAgent
      const isMac = /macintosh|mac os x/i.test(userAgent)
      const isWin = /windows|win32/i.test(userAgent)
      if (isWin) {
        window.open('https://fine-build.oss-cn-shanghai.aliyuncs.com/finereport/10.0/stable/exe/FinePrint_Windows_5_0.exe')
      } else if (isMac) {
        window.open('https://fine-build.oss-cn-shanghai.aliyuncs.com/finereport/10.0/stable/exe/FinePrint_macos_5_0.dmg')
      }
    }
  }
}
</script>
